require('./forget.less');
var ajax = require('@enhancer/fe-util-ajax');
var pageConfig = window.pageConfig;
var forget = require('./forget.html');
var locale = require('../../i18n');
var app = require('../../app/app');
var util = require('../../app/util');

function init () {
  var html = forget({
    locale: locale(),
  });

  $('.user-center-wrapper').append(html);
  //$('#error').css('display', 'block');
  function checkUserName (ele, next) {
    var val = ele.val().trim();
    if (util.isMobile(val)) {
      ele.removeClass('error');
      next && next();
    } else if (util.isEmail(val)) {
      ele.removeClass('error');
      next && next();
    } else {
      ele.next('label').text(locale('accountInvalid'));
      ele.addClass('error');
    }
  }

  $('#account').blur( function () {
    var self = this;
    setTimeout(function () {
      checkUserName($(self));
    }, 500);
  });
  
  $('.forget-form button[type=submit]').click( function (e) {
    e.preventDefault();
    checkUserName($('#account'), function () {
      var account = $('#account').val().trim();
      if (util.isMobile(account)) {
        try {
          localStorage.setItem('smsCode', Date.now())
        } catch (e) {
          
        }
      }

      ajax({
        url: '/api/forget',
        type: 'POST',
        data: {
          account: account
        }
      },function(ret) {
        if (ret.success) {
          if (util.isMobile(account)) {
            location.href = `/resetPassword?mobile=${account}`
          } else {
            location.href = `http://mail.${account.substring(account.lastIndexOf('@') + 1)}`
          }
        } else {
          util.show(ret.message, 'error');
        }
      });
    });
  });

  var errorMsg = $('#error').text();
  if (errorMsg) {
    util.show(errorMsg, 'error')
  }
}
init();



// WEBPACK FOOTER //
// ./src/pages/forget/forget.js